import 'bootstrap/dist/css/bootstrap.min.css' //TODO: maybe import intelligently from its SASS files?
import 'components/layout/fontAwesomeLibrary'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from 'state/_store'
import 'styles/general.scss'
import 'utils/Sentry.inc'
import App from './App'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'
// import reportWebVitals from './reportWebVitals'

/**
 * A plain spinner that mimics the raw CSS loader from Cordova and pre-React states.
 * If you need to test this out (since it tends to be very fast anyway), place the import call from Locale.js's resourcesToBackend() into a long-running setTimeout.
 * @returns {JSX.Element}
 * @internal This is NOT supposed to be used ANYWHERE except for Suspense!!! If you need to spin around waiting for any network request, use the actual `Spinner`/`SpinnerFull`, since it's API-aware and follows the FontAwesome icons we use all around the app.
 */
function SuspenseSpinner() {
	return <div id="splash-bg"><div id="spinner"></div></div> //the same code from our index.html and Cordova's index.html
}

//a separate function is needed so we can hot-reload below
const render = () => ReactDOM.render(
	<Provider store={store}>
		<PersistGate persistor={persistor} loading={null}>
			<Suspense fallback={<SuspenseSpinner/>}>
				<App/>
			</Suspense>
		</PersistGate>
	</Provider>,
	document.getElementById('root'))
render()

if (process.env.NODE_ENV !== 'production' && module.hot) {
	module.hot.accept('./router', render)
}

//We made a slight "update", bringing the newer version of SW and the "web vitals reporting"

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()
//TODO: maybe we're able to improve this worker? https://medium.com/@chinmaya.cp/custom-service-worker-in-cra-create-react-app-3b401d24b875

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
//TODO: start using this?
